/* melee-v2-features.js — migrated out of sections/melee-v2-features.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function initFeatures(root) {
      if (!root || root.dataset.mv2FeaturesReady === '1') return;
      root.dataset.mv2FeaturesReady = '1';

      /* Timeline (fractions of the section's scroll), tuned for this
         instance — a "two-step" reveal (pauseEnd: 1 means it holds on
         the two-column split rather than ever reaching a full-width B):
           [0 .. b1End]        BEAT 1  A full-width — flip-book (Text 1)
           [b1End .. t1End]    WIPE 1  A -> two-column (Text 1 out)
           [t1End .. 1]        BEAT 2  two-column HELD forever (Text 2 in) */
      var CONFIG = {
        dir: null, // frame URLs come from data-frames (JSON array) instead of a path pattern
        count: 71,
        mirror: root.dataset.mirror === 'true',
        b1End: 0.52,
        t1End: 0.7,
        pauseEnd: 1.0,
        t2End: 0.88,
        frameStart: 0.03,
        frameEnd: 0.48,
        smooth: 0.14,
      };

      var frameUrls = [];
      try {
        frameUrls = JSON.parse(root.dataset.frames || '[]');
      } catch (e) {
        frameUrls = [];
      }

      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mqStack = matchMedia('(max-width: 760px)'); // mobile: split top/bottom instead of left/right

      var section = root;
      var stage = root.querySelector('[data-mv2-features-stage]');
      var panelA = root.querySelector('.mv2-features__panel--a');
      var panelB = root.querySelector('.mv2-features__panel--b');
      var seam = root.querySelector('[data-mv2-features-seam]');
      // Heading and (optional) description are separate elements at
      // opposite edges now, both tagged data-mv2-features-text1 so they
      // fade/rise in lockstep instead of one being nested inside the other.
      var text1Els = root.querySelectorAll('[data-mv2-features-text1]');
      var text2 = root.querySelector('[data-mv2-features-text2]');
      var canvas = root.querySelector('[data-mv2-features-canvas]');
      var hasFlip = !!canvas && frameUrls.length > 0;
      var video = root.querySelector('[data-mv2-features-video]');
      var ctx = hasFlip ? canvas.getContext('2d') : null;
      if (!stage || !panelA || !panelB) return;

      initPanelAVideo(video);

      var BW = hasFlip ? canvas.width : 0,
        BH = hasFlip ? canvas.height : 0;
      var images = hasFlip ? new Array(CONFIG.count) : [];
      var drawnFrame = -1;
      var sp = 0,
        targetP = 0,
        rafId = null,
        ready2 = false;

      var clamp = function (v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      };
      var lerp = function (a, b, t) {
        return a + (b - a) * t;
      };
      var map = function (v, a, b) {
        return clamp((v - a) / (b - a));
      };
      var smoothstep = function (t) {
        return t * t * (3 - 2 * t);
      };

      /* divider: A's share of the stage (1 -> HOLD -> 0).
         HOLD is 0.5 (an even split) on desktop, where A's SHARE OF THE
         WIDTH only needs to fit the flip-book/video -- the corner text
         is a separate, still-unsolved sizing issue (see
         .mv2-features__atext-block's max-width in the liquid file).
         On mobile the split is vertical instead (see applyLayout's
         mqStack branch), so A's share is the actual on-screen height
         its heading/stat copy has to fit in -- held at an even 50% of
         the 100vh sticky stage, that's often under 400px on a real
         phone once nav chrome eats into it, which is what read as
         "squished". Giving mobile a taller held share (62%) instead
         directly answers that -- more of the pinned viewport goes to
         Panel A's text, less to Panel B's (comparatively more
         croppable) static photo. Desktop's 50/50 is untouched. */
      function beatDivider(p) {
        var b1End = CONFIG.b1End,
          t1End = CONFIG.t1End,
          pauseEnd = CONFIG.pauseEnd,
          t2End = CONFIG.t2End;
        var HOLD = mqStack.matches ? 0.7 : 0.5;
        if (p <= b1End) return 1;
        if (p <= t1End) return 1 - (1 - HOLD) * smoothstep(map(p, b1End, t1End));
        if (p <= pauseEnd) return HOLD;
        if (p <= t2End) return HOLD - HOLD * smoothstep(map(p, pauseEnd, t2End));
        return 0;
      }

      function drawFrame(i) {
        if (!hasFlip) return;
        i = clamp(i, 0, CONFIG.count - 1) | 0;
        if (i === drawnFrame) return;
        var img = images[i];
        // If this frame's image isn't decoded yet, leave the canvas alone
        // instead of clearing it -- clearing unconditionally here was
        // blanking the canvas on every attempt at a not-yet-ready frame
        // (e.g. scrolling ahead of preload/decode), which is what showed
        // up as flicker. Keep showing the last good frame; preload()'s
        // completion handler forces one final correct redraw once
        // everything is actually ready.
        if (!img || !img.complete || !img.naturalWidth) return;
        ctx.clearRect(0, 0, BW, BH);
        var s = Math.min(BW / img.naturalWidth, BH / img.naturalHeight);
        var w = img.naturalWidth * s,
          h = img.naturalHeight * s;
        ctx.drawImage(img, (BW - w) / 2, (BH - h) / 2, w, h);
        drawnFrame = i;
      }

      function applyLayout(d) {
        var W = stage.clientWidth,
          H = stage.clientHeight;
        var mir = CONFIG.mirror;

        if (mqStack.matches) {
          var dy = Math.round(H * d);
          if (mir) {
            panelB.style.left = '0';
            panelB.style.top = '0';
            panelB.style.width = '100%';
            panelB.style.height = H - dy + 'px';
            panelA.style.left = '0';
            panelA.style.top = H - dy + 'px';
            panelA.style.width = '100%';
            panelA.style.height = dy + 'px';
            if (seam) {
              seam.style.left = '0';
              seam.style.top = H - dy + 'px';
              seam.style.width = '100%';
              seam.style.height = '1px';
            }
          } else {
            panelA.style.left = '0';
            panelA.style.top = '0';
            panelA.style.width = '100%';
            panelA.style.height = dy + 'px';
            panelB.style.left = '0';
            panelB.style.top = dy + 'px';
            panelB.style.width = '100%';
            panelB.style.height = H - dy + 'px';
            if (seam) {
              seam.style.left = '0';
              seam.style.top = dy + 'px';
              seam.style.width = '100%';
              seam.style.height = '1px';
            }
          }
        } else {
          var dx = Math.round(W * d);
          if (mir) {
            panelB.style.top = '0';
            panelB.style.left = '0';
            panelB.style.width = W - dx + 'px';
            panelB.style.height = '100%';
            panelA.style.top = '0';
            panelA.style.left = W - dx + 'px';
            panelA.style.width = dx + 'px';
            panelA.style.height = '100%';
            if (seam) {
              seam.style.top = '0';
              seam.style.left = W - dx + 'px';
              seam.style.width = '1px';
              seam.style.height = '100%';
            }
          } else {
            panelA.style.left = '0';
            panelA.style.top = '0';
            panelA.style.width = dx + 'px';
            panelA.style.height = '100%';
            panelB.style.top = '0';
            panelB.style.left = dx + 'px';
            panelB.style.width = W - dx + 'px';
            panelB.style.height = '100%';
            if (seam) {
              seam.style.top = '0';
              seam.style.left = dx + 'px';
              seam.style.width = '1px';
              seam.style.height = '100%';
            }
          }
        }

        if (seam) {
          var both = Math.min(d, 1 - d) / 0.5;
          seam.style.opacity = String(smoothstep(clamp(both)) * 0.9);
        }
      }

      function applyText(p, enter) {
        var b1End = CONFIG.b1End,
          t1End = CONFIG.t1End,
          pauseEnd = CONFIG.pauseEnd;
        var RISE = 72; // px — matches the promo headline's --rise: 4.5rem

        if (text1Els && text1Els.length) {
          var eOp = smoothstep(clamp(enter / 0.4));
          var eDy = (1 - smoothstep(enter)) * RISE;
          var out1 = smoothstep(map(p, b1End, b1End + 0.12));
          var exitOp = 1 - smoothstep(clamp((out1 - 0.5) / 0.5));
          var op1 = String(eOp * exitOp);
          var dy1 = (eDy - RISE * out1).toFixed(1) + 'px';
          for (var t1 = 0; t1 < text1Els.length; t1++) {
            text1Els[t1].style.opacity = op1;
            text1Els[t1].style.setProperty('--dy', dy1);
          }
        }

        if (text2) {
          var in2 = map(p, t1End + 0.01, t1End + 0.16);
          var inP = smoothstep(in2);
          var out2 = pauseEnd >= 1 ? 0 : smoothstep(map(p, pauseEnd + 0.02, CONFIG.t2End - 0.05));
          text2.style.opacity = String(smoothstep(clamp(in2 / 0.4)) * (1 - smoothstep(clamp((out2 - 0.5) / 0.5))));
          text2.style.setProperty('--dy', ((1 - inP) * RISE - out2 * RISE).toFixed(1) + 'px');
        }
      }

      function render() {
        var enter = reduce
          ? 1
          : clamp((window.innerHeight - section.getBoundingClientRect().top) / (window.innerHeight * 0.55));
        applyLayout(beatDivider(sp));
        applyText(sp, enter);
        if (hasFlip) {
          var idx = map(sp, CONFIG.frameStart, CONFIG.frameEnd) * (CONFIG.count - 1);
          drawFrame(Math.round(idx));
        }
      }

      function computeTarget() {
        var rect = section.getBoundingClientRect();
        var scrollable = rect.height - window.innerHeight;
        targetP = scrollable > 0 ? clamp(-rect.top / scrollable) : 0;
      }

      function tick() {
        var diff = targetP - sp;
        if (Math.abs(diff) < 0.0004) {
          sp = targetP;
          render();
          rafId = null;
          return;
        }
        sp += diff * CONFIG.smooth;
        render();
        rafId = requestAnimationFrame(tick);
      }
      function requestTick() {
        if (rafId == null) rafId = requestAnimationFrame(tick);
      }

      function onScroll() {
        computeTarget();
        if (reduce) {
          sp = targetP;
          render();
          return;
        }
        requestTick();
      }
      function onResize() {
        computeTarget();
        render();
      }

      function preload() {
        if (!hasFlip) return Promise.resolve();
        var tasks = [];
        for (var i = 0; i < CONFIG.count; i++) {
          var img = new Image();
          img.decoding = 'async';
          img.src = frameUrls[i];
          images[i] = img;
          tasks.push((img.decode ? img.decode() : Promise.resolve()).catch(function () {}));
        }
        return Promise.all(tasks);
      }

      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      // applyLayout() reads stage.clientWidth/clientHeight -- if this
      // script runs before layout has fully settled (fonts/images/CSS
      // still resolving), that first read can be 0 or stale, leaving
      // panel B sized wrong until the next scroll/resize. `load` fires
      // once everything (styles, images) has actually finished, so this
      // guarantees one final correct pass without waiting on the user to
      // scroll or resize first.
      window.addEventListener('load', function () {
        computeTarget();
        render();
      });

      computeTarget();
      render();

      preload().then(function () {
        ready2 = true;
        if (reduce) {
          sp = 0.48;
          drawnFrame = -1;
          render();
        } else {
          computeTarget();
          sp = targetP;
          drawnFrame = -1;
          render();
        }
      });

      if (images[0]) {
        (images[0].decode ? images[0].decode() : Promise.resolve()).then(
          function () {
            if (!ready2) {
              drawnFrame = -1;
              drawFrame(0);
            }
          },
          function () {}
        );
      }
    }

    /* ---- Panel A video, when that's the chosen media: same behavior as
       the Handlebar & Tape section's heatmap clip -- plays once scrolled
       into view, pauses and resets when it scrolls out so it replays
       cleanly on re-entry. Independent of the scroll-scrub render loop
       above, which only drives the flip-book/layout wipe. ---- */
    function initPanelAVideo(vid) {
      if (!vid) return;

      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        vid.pause(); // leave the poster/first frame still either way
        return;
      }

      if (vid.dataset.autoplay !== 'scroll') return; // 'auto' mode: native autoplay+loop attributes already handle it

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              try {
                vid.currentTime = 0;
              } catch (e) {}
              var p = vid.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              vid.pause();
              try {
                vid.currentTime = 0;
              } catch (e) {} // arm it to replay on re-entry
            }
          });
        },
        { threshold: 0.35 }
      );

      io.observe(vid);
    }

    function initAll() {
      document.querySelectorAll('[data-mv2-features]').forEach(initFeatures);
    }

    ready(initAll);
    document.addEventListener('shopify:section:load', function (evt) {
      var root = evt.target && evt.target.querySelector ? evt.target.querySelector('[data-mv2-features]') : null;
      if (root) {
        root.dataset.mv2FeaturesReady = '0';
        initFeatures(root);
      }
    });
  })();
